import script from "./ShopCartOrderShippingMethod.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopCartOrderShippingMethod.vue?vue&type=script&lang=ts&setup=true"

import "./ShopCartOrderShippingMethod.vue?vue&type=style&index=0&id=70b2ccaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b2ccaa"]])

export default __exports__